module.exports = __webpack_public_path__ + "img/LinkedIn_Logo.275e06ab.svg";